export default {
  labels: {
    today: 'Hoy',
    pickup_time: 'Hora de recogida',
    on_site_time: 'Hora de servicio',
    delivery_time: 'Hora de entrega',
  },
};
